/**
 * SessionStorage key used to persist the ID of a newly created playlist
 * across page redirects. This allows the destination page to automatically
 * open the edit view for the created playlist.
 *
 * Used by:
 * - CreatePlaylistForm: Sets the key when a playlist is created with a redirect URL
 * - PlaylistsTab: Reads and clears the key on mount to show the edit section
 */
export const createdPlaylistStorageKey = "kmsCreatedPlaylistId";
